import axiosInstance from "../../../helpers/api";

export const getAllSections = (id) => {
  return axiosInstance.get(`/student/sections/${id}`);
};

export const getSection = (id) => {
  return axiosInstance.get(`/students/chapters/for_section/${id}`);
};
